module.exports = __webpack_public_path__ + "img/The.2c4cb7fb.png";